import {
  GET_VERIFICATION_LINK,
  GET_VERIFICATION_LINK_SUCCESS,
  GET_VERIFICATION_LINK_FAIL,
  CHECK_KYC_STATUS,
  CHECK_KYC_STATUS_SUCCESS,
  CHECK_KYC_STATUS_FAIL,
  UPDATE_PROFILE_AFTER_KYC,
} from './actionTypes';

export const getVerificationLink = () => ({
  type: GET_VERIFICATION_LINK,
});

export const getVerificationLinkSuccess = (url) => ({
  type: GET_VERIFICATION_LINK_SUCCESS,
  payload: url,
});

export const getVerificationLinkFail = (error) => ({
  type: GET_VERIFICATION_LINK_FAIL,
  payload: error,
});

export const checkKYCStatus = () => ({
  type: CHECK_KYC_STATUS,
});

export const checkKYCStatusSuccess = () => ({
  type: CHECK_KYC_STATUS_SUCCESS,
});

export const checkKYCStatusFail = (error) => ({
  type: CHECK_KYC_STATUS_FAIL,
  payload: error,
});

export const updateProfileAfterKYC = () => ({
  type: UPDATE_PROFILE_AFTER_KYC,
});
